import React, { useState, useEffect } from "react";
import { BsArrowLeft } from "react-icons/bs";
import { FiCopy } from "react-icons/fi";
import { RiErrorWarningFill } from "react-icons/ri";
import QRCode from "react-qr-code";
import GetExWallet from "../../../components/utils/GetExSellAddy";
import { truncateWord } from "../../../utils/wordFunctions";
import { useUser } from "../../../context/user-context";
import { PiSealWarningFill } from "react-icons/pi";
import { IoClose } from "react-icons/io5";
import CopyToClipboard from "../../../components/utils/CopyToClipboard";
import { useQueryClient } from "@tanstack/react-query";
import { getNetworkLabel } from "../../../constants/constants";
import { invalidateActivityQueries } from "../../../utils/invalidateActivityQueries";

const TransferFund = ({
  setOpenSellPending,
  setOpenSellTransfer,
  setOpenSellFromExAddy,
  selectedNetwork,
  selectedCoinObj,
  setSelectedNetwork,
}: any) => {
  const { theme: userTheme } = useUser();
  const queryClient = useQueryClient();
  const [showDisclaimer, setShowDisclaimer] = useState<boolean>(false);
  const [timeLeft, setTimeLeft] = useState<number>(5);

  useEffect(() => {
    // Check if user has previously chosen to not show the disclaimer
    const shouldShowDisclaimer =
      localStorage.getItem("hideTransferDisclaimer") !== "true";
    if (shouldShowDisclaimer) {
      setShowDisclaimer(true);
      setTimeLeft(5);
      // Auto-dismiss after 5 seconds
      const timer = setTimeout(() => {
        setShowDisclaimer(false);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, []);

  useEffect(() => {
    if (showDisclaimer && timeLeft > 0) {
      const countdownTimer = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);
      return () => clearInterval(countdownTimer);
    }
  }, [showDisclaimer, timeLeft]);

  const handleDontShowAgain = () => {
    localStorage.setItem("hideTransferDisclaimer", "true");
    setShowDisclaimer(false);
  };

  const handleNetworkChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedNetwork(e.target.value);
  };

  const walletAddy = GetExWallet(selectedCoinObj?.abbr, selectedNetwork);
  // // console.log(walletAddy);

  // const getWallet = async () => {
  //   const response = await axiosInstance.get(
  //     API.getCryptoWallet(selectedCoinObj?.abbr?.toUpperCase())
  //   );
  //   return response.data;
  // };

  // const { data: walletAddresses } = useQuery({
  //   queryKey: ["get-wallet-addresses"],
  //   queryFn: getWallet,
  //   retry: 1,
  // });
  // console.log(walletAddresses);

  return (
    <div className="fixed inset-0 overflow-auto pb-16  flex font-manrope justify-start items-start pt-16  bg-[#E7EBEE] dark:bg-primary_dark dark:bg-opacity-95  backdrop-blur-sm">
      <div
        className={` w-11/12 mds:w-8/12 md:7/12 border dark:border-[#303030] bg-white  rounded-xl mx-auto p-6 dark:bg-[#192025]   lgss:w-2/5 xxl:w-1/3 `}
      >
        {/* Disclaimer Modal */}
        {showDisclaimer && (
          <div className="inset-0 fixed  bg-black bg-opacity-80">
            <div className="absolute bottom-[40%] left-1/2 font-sora transform border-l-4 border-[#DF4E4E] -translate-x-1/2 w-11/12 max-w-sm bg-white dark:bg-[#1C2227] rounded-r-xl shadow-lg p-4 transition-all duration-300 ease-in-out">
              <div className="flex justify-between items-start mb-2">
                <div className="flex items-center gap-2 p-2 bg-[#DF4E4E] rounded-lg">
                  <h4 className="text-white font-semibold text-[14px]">
                    Minimum Deposit Required
                  </h4>
                </div>
                <button
                  onClick={() => setShowDisclaimer(false)}
                  className="text-gray-500"
                >
                  <IoClose className="text-xl" />
                </button>
              </div>
              <p className="text-gray-700 dark:text-gray-300 text-[13px] mb-3">
                To avoid losses, ensure that your transactions meet or exceed
                the $10 minimum requirement for your{" "}
                {selectedCoinObj?.abbr.toUpperCase()}
                transaction
              </p>
              <div className="flex justify-between flex-row-reverse items-center">
                <button
                  onClick={handleDontShowAgain}
                  className="text-secondary_button text-sm underline"
                >
                  Don't show again
                </button>
                <div className="text-xs text-gray-500">0:0{timeLeft}</div>
              </div>
            </div>
          </div>
        )}

        <div className="w-full flex justify-start gap-6 items-center">
          <button
            onClick={() => {
              setOpenSellTransfer(false);
              setOpenSellFromExAddy(true);
            }}
          >
            <BsArrowLeft className="text-black dark:text-white text-[20px]" />
          </button>
          <h4 className="text-gray-900 dark:text-gray-100 font-sora font-semibold text-[20px]">
            Sell {selectedCoinObj?.abbr}
          </h4>
        </div>
        <div className="w-full mt-4">
          <div className="">
            <div className="w-full flex flex-col items-center justify-center ">
              <div className="w-full flex flex-col items-center justify-center ">
                {!showDisclaimer && (
                  <div className="w-2/5 mx-auto h-[40px]  top-7  rounded-full relative flex justify-center items-center text-[10px] xs:text-[12px] dark:bg-[#99caf0] font-bold  bg-[#D4EBFD]">
                    WALLET NETWORK
                  </div>
                )}
              </div>

              <div className="h-[48px] mt-2 rounded-xl border border-gray-300 dark:border-gray-600 px-2 w-full flex gap-1 justify-start items-center">
                <select
                  value={selectedNetwork}
                  onChange={handleNetworkChange}
                  className="outline-none w-full bg-transparent text-[14px] text-gray-800 dark:text-gray-200"
                >
                  <option value="" disabled>
                    Select a Network
                  </option>
                  {selectedCoinObj?.networks.map((network: any, index: any) => (
                    <option key={index} value={network.name}>
                      {getNetworkLabel(network.name)}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
          <h4 className="text-gray-500 dark:text-gray-400 text-[13px] mt-4 text-center">
            Scan the QR code or copy the payment wallet
          </h4>
          {walletAddy && (
            <div className="w-full flex justify-center mt-6 items-center">
              <QRCode
                size={160}
                bgColor={
                  userTheme === "light"
                    ? "#F1F1F1"
                    : userTheme === "dark"
                    ? "#1F1F1F"
                    : ""
                }
                fgColor={
                  userTheme === "light"
                    ? "#1D2739"
                    : userTheme === "dark"
                    ? "#E4E7EC"
                    : ""
                }
                value={walletAddy ?? ""}
              />
            </div>
          )}

          <div className="flex justify-between text-[12px] mt-6 text-gray-800 dark:text-gray-200  items-center border bg-transparent border-gray-200 dark:border-gray-600 rounded-xl px-4 h-[52px]">
            <h4>{truncateWord(walletAddy ?? "")}</h4>
            <CopyToClipboard text={walletAddy ?? ""}>
              <FiCopy className="text-[16px]  text-gray-800 dark:text-gray-200" />
            </CopyToClipboard>
          </div>

          <div className="flex justify-center items-start py-3  gap-4 px-4 bg-[#E8F3FC] dark:bg-[#9AD1F9] w-full  mt-6  rounded-lg">
            <div>
              <RiErrorWarningFill className="text-[30px] text-secondary_button" />
            </div>
            <div>
              <h4 className="text-[13px]">
                To avoid losing your fund, please ensure you're sending{" "}
                <span className="font-bold"> {selectedCoinObj?.abbr}</span> from
                a{" "}
                <span className="font-bold">
                  {" "}
                  {getNetworkLabel(selectedNetwork)} network
                </span>{" "}
                above.
              </h4>
              <h4 className="text-[13px] mt-1">
                Payout above <span className="font-bold">5,000,000</span> Naira
                will be paid in batches.
              </h4>
            </div>
          </div>
          <div className="flex z-50 justify-start bg-[#FDE8E8] w-full p-4 items-center rounded-xl mt-4 gap-3">
            <div>
              <PiSealWarningFill className="text-[24px] text-[#DF4E4E]" />
            </div>

            <div>
              <h4 className=" text-[#DF4E4E]    text-[13px] font-semibold">
                Minimum Deposit is $10 worth worth of {selectedCoinObj?.abbr}
              </h4>
            </div>
          </div>
          <button
            onClick={() => {
              queryClient.invalidateQueries({ queryKey: ["userDetails"] });
              invalidateActivityQueries(queryClient);
              setOpenSellTransfer(false);
              setOpenSellPending(true);
            }}
            className="mt-6 bg-secondary_button flex justify-center items-center text-white text-[15px] font-medium h-[48px] w-full rounded-xl"
          >
            I've made the deposit
          </button>
        </div>
      </div>
    </div>
  );
};

export default TransferFund;
